import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { useEffect, useState } from 'react';
import useNav from '../hooks/useNav';
import { beaconSelector } from '../recoil/selector';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';
import { isIOS } from 'react-device-detect';
import { useParams } from 'react-router-dom';

export const useMtgConfirm = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_CONFIRM,
  });
  const { media } = useParams();

  const clickPopupBtn = (btnNm: string, Yn: string) => {
    beacon.sendClkBtnPopup({
      properties: { btn_name: `${btnNm}_${Yn}` },
    });
  };

  const [mortgageInfo] = useRecoilState(Atom.mortgageInfo);

  const sendBeaconClkBtnNext = () => {
    beacon.sendClkBtnNext({
      properties: {
        loan_amount: mortgageInfo.previousAmt ?? '',
        hope_loan_amount: mortgageInfo.hopefulAmt ?? '',
      },
    });
  };

  const sendBeaconClkBtnOption = ({
    btmsheet_name,
    option_name,
    before_option_name,
  }: IClkBtnOptionProperties) => {
    beacon.sendClkBtnOption({
      properties: <IClkBtnOptionProperties>{
        btmsheet_name: btmsheet_name,
        option_name: option_name,
        before_option_name: before_option_name,
      },
    });
  };

  useEffect(() => {
    beacon.sendViewPage();
  }, []);
  const [isActive] = useState<boolean>(true);

  // navigate
  const { navigate } = useNav();
  const navigateFromMtg = () => {
    navigate(
      process.env.REACT_APP_ENV !== 'production'
        ? '/conditions/2'
        : '/conditions/1',
      { state: { ref_page: PAGE_NM.MTG_CONFIRM }, replace: true },
    );
  };

  // popup
  const DEFAULT_POPUP_STATE = {
    message: '',
    confirmText: '',
    cancelText: '',
    onClickConfirmButton: () => {},
    onClickCancelButton: () => {},
    isPopupOpen: false,
  };

  const [popup, setPopup] = useState<any>(DEFAULT_POPUP_STATE);
  const onClickPopupField = (val: string, fn: any) => {
    setPopup((prev: any) => {
      return {
        ...prev,
        isPopupOpen: true,
        message: `${val} 수정은\n 해당 페이지에서 가능해요.\n 이동하시겠어요?`,
        confirmText: '예',
        cancelText: '아니요',
        onClickConfirmButton: () => {
          fn();
          clickPopupBtn(val, 'y');
        },
        onClickCancelButton: () => {
          setPopup(DEFAULT_POPUP_STATE);
          clickPopupBtn(val, 'n');
        },
      };
    });
  };

  return {
    navigateFromMtg,
    isActive,
    popup,
    onClickPopupField,
    sendBeaconClkBtnNext,
    sendBeaconClkBtnOption,
  };
};
